module.exports = __webpack_public_path__ + "static/media/woman-drink@2x.833a50a0.jpg";